import { useEffect, useState } from 'react';
import { Card, Col, ListGroup, ListGroupItem, Row, Alert, Container } from 'react-bootstrap';
import { TelephoneFill, Clock, PersonCircle, At, ExclamationCircleFill, PhoneFill, Phone, PinMapFill, Building, Whatsapp } from 'react-bootstrap-icons';

import { getLocalidades, getLocalidade } from '../services/api';

import NavBar from '../components/Navbar';
import LinkGoogle from '../components/LinkGoogle';
import CardsEleitorado from '../components/CardsEleitorado';
import SelectLocalidade from '../components/SelectLocalidade';

function Home(props) {

  const [zonas, setZonas] = useState(false);
  const [postos, setPostos] = useState(false);
  const [mensagem, setMensagem] = useState(false);
  const [semAtendimento, setSemAtendimento] = useState(false);
  const [localidades, setLocalidades] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [eleitorado, setEleitorado] = useState(false);
  const [secoes, setSecoes] = useState(false);
  const [locais, setLocais] = useState(false);
  const [links, setLinks] = useState({});

  useEffect(() => {
    getLocalidades().then(result => {
      setLocalidades(result.data)
      setLoading(false)
    })
  }, []);

  const loadData = (localidade) => {
    setLoading(true)
    getLocalidade(localidade).then(result => {
      if (result.data.sucesso) {
        setPostos(result.data.postos);
        setZonas(result.data.zonas);
        setMensagem(result.data.mensagem);
        setEleitorado(result.data.eleitorado.toLocaleString('pt-BR'));
        setSecoes(result.data.secoes);
        setLocais(result.data.locais);
        setLinks(result.data.links);
      } else {
        setSemAtendimento(true)
      }
      setLoading(false);
    })
  }

  const showTelefone = (telefone) => {
    return (telefone && (props?.modulo === "advogado" || !telefone?.includes("3251")))
  }

  return (
    <>
      <NavBar title="Cartórios Eleitorais" subtitle="Endereços e Contatos" />
      <Container>

        <Row style={{ marginTop: 120 }}>
          <Col xs={12} sm={12} md={12} lg={12} className="mx-auto" >
            <Card style={{ paddingLeft: 15, paddingRight: 15, paddingTop: 10, paddingBottom: 10 }}>
              <SelectLocalidade isLoading={isLoading} setLoading={setLoading} loadData={loadData} localidades={localidades} />

              {!isLoading && eleitorado && (
                <CardsEleitorado locais={locais} secoes={secoes} eleitorado={eleitorado} />
              )
              }

            </Card>
          </Col>
        </Row>


        {!isLoading && semAtendimento &&
          (
            <Row style={{ marginTop: 15 }}>
              <Col md={6} className="mx-auto">
                <Alert variant="info" className="text-center">
                  Não encontramos atendimento para sua localização. Tente outro município.
                </Alert>
              </Col>
            </Row>
          )
        }


        {!isLoading && mensagem && mensagem.map(mm => {
          return (
            <Row style={{ marginTop: 10 }} key={mm.id}>
              <Col md={6} className="mx-auto">
                <Alert variant="warning" className="text-center">
                  <b><ExclamationCircleFill /> Atenção {mm.zona}ª Zona Eleitoral</b>
                  <hr />
                  {mm.mensagem}
                </Alert>
              </Col>
            </Row>
          )
        })
        }

        {!isLoading && postos && postos.map(posto => {
          return (
            <Row style={{ marginTop: 15 }} key={posto.id}>
              <Col md={12} className="mx-auto">
                <Card sm={12} style={{ marginBottom: 20, borderRadius: 10 }} className="shadow-sm" >
                  <Card.Header style={{ backgroundColor: "#596f99", color: "#fff" }}>
                    <Card.Title style={{ marginBottom: 0 }}>{posto.nome}</Card.Title>
                  </Card.Header>
                  <Card.Body >

                    <Card.Text>
                      <span>
                        <TelephoneFill />  {posto.telefone ? (<a href={"tel:" + posto.telefone.replace(/\D/g, '')}>{posto.telefone}</a>) : ''} <br />
                      </span>
                      {props.modulo === "advogado" &&
                        <span style={{ marginTop: 25, lineHeight: 1 }}>
                          <PhoneFill />  {posto.fax ? (<a href={"tel:" + posto.fax.replace(/\D/g, '')}><b>{posto.fax}</b></a>) : ('Não Informado')} <br />
                        </span>
                      }
                      <br />
                      <span style={{ marginTop: 25, lineHeight: 1 }}>
                        <Whatsapp />  Tire suas dúvidas no <a target='_blank' rel="noreferrer" href={links.chatbotJE.link}>{links.chatbotJE.label}</a><br />
                      </span>
                      <span style={{ marginTop: 25, lineHeight: 1 }}>
                        <TelephoneFill />  <b><a href={links.disqueEleitor.link}>{links.disqueEleitor.label}</a></b> (Disque-Eleitor / Segunda a Sexta-feira, das 13h às 19h) <br />
                      </span>

                      <br />
                      <span style={{ marginTop: 25, lineHeight: 1 }}>
                        <LinkGoogle endereco={posto.endereco} municipio={posto.municipio} cep={posto.cep} />
                      </span>

                    </Card.Text>
                    {
                      posto.observacao ? (
                        <p className="text-center" style={{ marginTop: 15, backgroundColor: '#cff4fc', borderColor: '#b6effb' }}>
                          <b>Atenção:</b>
                          <br />
                          {posto.observacao}
                        </p>
                      ) : null
                    }
                  </Card.Body>
                  <ListGroup className="list-group-flush">
                    {
                      posto.zona_responsavel ? <ListGroupItem style={{ padding: 5, paddingLeft: 20 }}> <Building />  {posto.zona_responsavel}ª Zona Eleitoral <br /><span style={{ marginLeft: 20, fontSize: '0.8em', fontStyle: 'italic' }}>Zona Eleitoral Responsável</span></ListGroupItem> : ''
                    }
                    {
                      posto.chefe_responsavel ? <ListGroupItem style={{ padding: 5, paddingLeft: 20 }}> <PersonCircle />  {posto.chefe_responsavel} <br /><span style={{ marginLeft: 20, fontSize: '0.8em', fontStyle: 'italic' }}>Chefe do Cartório Responsável</span></ListGroupItem> : ''
                    }
                  </ListGroup>
                  <Card.Footer className='text-right' style={{ fontSize: 10, fontStyle: "italic" }}>
                    Atualizado em: {new Date().toLocaleDateString('pt-BR')}
                  </Card.Footer>
                </Card>
              </Col>
            </Row>
          )
        })
        }

        {!isLoading && zonas && zonas.map(zona => {
          return (
            <Row style={{ marginTop: 10 }} key={zona.id}>
              <Col md={12} className="mx-auto">
                <Card sm={12} style={{ marginBottom: 20, borderRadius: 10 }} className="shadow-sm" >
                  <Card.Header style={{ backgroundColor: "#596f99", color: "#fff" }}>
                    <Card.Title style={{ marginBottom: 0, textTransform: "uppercase" }}>{zona.nome} - <span>{zona.sede}</span></Card.Title>
                  </Card.Header>
                  <Card.Body >
                    {
                      zona.observacao ? (
                        <p className="text-center" style={{ marginTop: 15, backgroundColor: '#cff4fc', borderColor: '#b6effb' }}>
                          <b>Atenção:</b>
                          <br />
                          {zona.observacao}
                        </p>
                      ) : null
                    }
                    <Card.Text>
                      <span>
                        <PinMapFill />  Jurisdição <span style={{ fontSize: '0.8em', marginLeft: 22, textAlign: "justify" }} dangerouslySetInnerHTML={{ __html: zona.jurisdicao }}></span><br />
                      </span>
                      <span>
                        <Clock />  <b>{zona.atendimento ?? 'Não Informado'}</b><br />
                      </span>
                      <span>
                        <TelephoneFill /> {showTelefone(zona?.telefone) ? (<a href={"tel:" + zona.telefone.replace(/\D/g, '')}><b>{zona.telefone}</b></a>) : ('Não Informado')}
                        {showTelefone(zona?.telefone2) ? (<> / <a href={"tel:" + zona.telefone2.replace(/\D/g, '')}><b>{zona.telefone2}</b></a></>) : ('')}
                        <br />
                      </span>
                      {props.modulo === "advogado" &&
                        <span style={{ marginTop: 25, lineHeight: 1 }}>
                          <Phone />  {zona.fax ? (<a href={"tel:" + zona.fax.replace(/\D/g, '')}><b>{zona.fax}</b></a>) : ('Não Informado')} <br />
                        </span>
                      }
                      <br />
                      <span style={{ marginTop: 25, lineHeight: 1 }}>
                        <Whatsapp />  Tire suas dúvidas no <a target='_blank' rel="noreferrer" href={links.chatbotJE.link}>{links.chatbotJE.label}</a><br />
                      </span>
                      <span style={{ marginTop: 25, lineHeight: 1 }}>
                        <TelephoneFill />  <b><a href={links.disqueEleitor.link}>{links.disqueEleitor.label}</a></b> (Disque-Eleitor / Segunda a Sexta-feira, das 13h às 19h) <br />
                      </span>
                      <br />
                      <LinkGoogle endereco={zona.endereco} municipio={zona.municipio} cep={zona.cep} />
                      <br />
                      <span >
                        <At /> <a href={"mailto:" + zona.email}>{zona.email}</a> <br />
                      </span>

                    </Card.Text>
                  </Card.Body>
                  <ListGroup className="list-group-flush">

                    {
                      zona.juiz ? <ListGroupItem style={{ padding: 5, paddingLeft: 20 }}> <PersonCircle />  {zona.juiz} <br /><span style={{ marginLeft: 20, fontSize: '0.8em', fontStyle: 'italic' }}>Juiz Eleitoral</span></ListGroupItem> : ''
                    }
                    {
                      zona.promotor ? <ListGroupItem style={{ padding: 5, paddingLeft: 20 }}> <PersonCircle />  {zona.promotor} <br /><span style={{ marginLeft: 20, fontSize: '0.8em', fontStyle: 'italic' }}>Promotor Eleitoral</span></ListGroupItem> : ''
                    }
                    {
                      zona.chefe ? <ListGroupItem style={{ padding: 5, paddingLeft: 20 }}> <PersonCircle />  {zona.chefe}<br /> <span style={{ marginLeft: 20, fontSize: '0.8em', fontStyle: 'italic' }}>Chefe do Cartório</span> </ListGroupItem> : ''
                    }
                  </ListGroup>
                  <Card.Footer className='text-right' style={{ fontSize: 10, fontStyle: "italic" }}>
                    Atualizado em: {new Date().toLocaleDateString('pt-BR')}
                  </Card.Footer>
                </Card>
              </Col>
            </Row>
          )
        })
        }

      </Container>
    </>
  );
}

export default Home;